import { render, staticRenderFns } from "./toolPosition.vue?vue&type=template&id=71a7f47a"
import script from "./toolPosition.vue?vue&type=script&lang=js"
export * from "./toolPosition.vue?vue&type=script&lang=js"
import style0 from "./toolPosition.vue?vue&type=style&index=0&id=71a7f47a&prod&lang=scss&scope=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports